import { LicenseException } from '@/domain/licensing/exception/LicenseException'

export class ActivationAlreadyExistException extends LicenseException
{

}
